package com.gsb.vyapar.bhagya.mqtt

import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTEvents
import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTManager
import com.gsb.vyapar.bhagya.datasource.mqtt.mqttCaCertificatePem
import com.gsb.vyapar.bhagya.util.getMQTTPassword
import com.gsb.vyapar.bhagya.util.getMQTTUrl
import com.gsb.vyapar.bhagya.util.getMQTTUserName
import com.gsb.vyapar.bhagya.util.getMQTTWebPort

external fun createMQTTClient()

external fun connect()

external fun disconnect()

external fun publish(topic: String, message: String)

external fun subscribe(topic: String)

external fun unsubscribe(topic: String)

@OptIn(ExperimentalJsExport::class)
@JsExport
fun connectionLost(message: String?) {
    MQTTManager.onTriggerMQTTEvent(MQTTEvents.OnDisconnected(message ?: "Unknown Error"))
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun messageArrived(topic: String?, message: String?) {
    MQTTManager.onTriggerMQTTEvent(MQTTEvents.OnMessageReceived(topic.orEmpty(), message.orEmpty()))
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun connectComplete() {
    MQTTManager.onTriggerMQTTEvent(MQTTEvents.OnConnected)
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun getMqttUrl(): String {
    return getMQTTUrl()
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun getMqttPort(): Int {
    return getMQTTWebPort().toInt()
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun getMqttUserName(): String {
    return getMQTTUserName()
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun getMqttPassword(): String {
    return getMQTTPassword()
}
@OptIn(ExperimentalJsExport::class)
@JsExport
fun getMqttCertificatePem(): String {
    return mqttCaCertificatePem()
}
